export const getReasonOfFareIssue = (result) => {
  switch (result) {
    case "incorrectFare":
      return "Opłata za czas przejazdu";
    case "vehicleTechnicalIssue":
      return "Usterka roweru";
    case "bikeLeftOutOfPreferredZone":
      return "Opłata za pozostawienie roweru poza strefą ROOVEE PARK";
    case "bikeLeftOutOfOperatorZone":
      return "Opłata za pozostawienie roweru poza strefą operatora";
    case "other":
      return "Inne";
    case "cancelRental":
      return "Rezygnacja z wypożyczenia";
    case "bonusIssue":
      return "Bonus";
    default:
      return "Brak informacji";
  }
};

export const getResultOfFareIssue = (result) => {
  switch (result) {
    case 1:
    case "acknowledged":
      return "Uznana";
    case 2:
    case "rejected":
      return "Odrzucona";
    default:
      return "Brak informacji";
  }
};

export const getResultCorrectionReasonFareIssue = (result) => {
  switch (result) {
    case "feeAdjustment":
      return "Korekta opłaty";
    case "rentalCancellation":
      return "Rezygnacja z wypożyczenia";
    case "bikeReturnedToParkingZone":
      return "Rower zwrócony do Strefy Parkowania";
    case "bikeLeftInOperatorArea":
      return "Rower pozostawiony w Obszarze Operatora";
    case "gPSFailure":
      return "Błąd GPS";
    case "bikeFault":
      return "Usterka roweru";
    case "other":
      return "Inne";
    case "noFoundIssue":
      return "Brak zidentyfikowanych problemów";
    default:
      return "Brak informacji";
  }
};
